module.exports = {
    "dismiss": `Ignora`
};


//# sourceMappingURL=it-IT.main.js.map
